import { render, staticRenderFns } from "./takeLoc.vue?vue&type=template&id=7403f338&scoped=true"
import script from "./takeLoc.vue?vue&type=script&lang=js"
export * from "./takeLoc.vue?vue&type=script&lang=js"
import style0 from "./takeLoc.vue?vue&type=style&index=0&id=7403f338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7403f338",
  null
  
)

export default component.exports